import { jsonData } from "./Cities";

export const stateOptions = [
  { value: null, text: "Select a State" },
  { value: "Andaman and Nicobar Islands", text: "Andaman and Nicobar Islands" },
  { value: "Andhra Pradesh", text: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", text: "Arunachal Pradesh" },
  { value: "Assam", text: "Assam" },
  { value: "Bihar", text: "Bihar" },
  { value: "Chandigarh", text: "Chandigarh" },
  { value: "Chhattisgarh", text: "Chhattisgarh" },
  { value: "Dadra and Nagar Haveli", text: "Dadra and Nagar Haveli" },
  { value: "Daman and Diu", text: "Daman and Diu" },
  { value: "Delhi", text: "Delhi" },
  { value: "Goa", text: "Goa" },
  { value: "Gujarat", text: "Gujarat" },
  { value: "Haryana", text: "Haryana" },
  { value: "Himachal Pradesh", text: "Himachal Pradesh" },
  { value: "Jammu and Kashmir", text: "Jammu and Kashmir" },
  { value: "Jharkhand", text: "Jharkhand" },
  { value: "Karnataka", text: "Karnataka" },
  { value: "Kerala", text: "Kerala" },
  { value: "Lakshadweep", text: "Lakshadweep" },
  { value: "Madhya Pradesh", text: "Madhya Pradesh" },
  { value: "Maharashtra", text: "Maharashtra" },
  { value: "Manipur", text: "Manipur" },
  { value: "Meghalaya", text: "Meghalaya" },
  { value: "Mizoram", text: "Mizoram" },
  { value: "Nagaland", text: "Nagaland" },
  { value: "Odisha", text: "Odisha" },
  { value: "Puducherry", text: "Puducherry" },
  { value: "Punjab", text: "Punjab" },
  { value: "Rajasthan", text: "Rajasthan" },
  { value: "Sikkim", text: "Sikkim" },
  { value: "Tamil Nadu", text: "Tamil Nadu" },
  { value: "Telangana", text: "Telangana" },
  { value: "Tripura", text: "Tripura" },
  { value: "Uttar Pradesh", text: "Uttar Pradesh" },
  { value: "Uttarakhand", text: "Uttarakhand" },
  { value: "West Bengal", text: "West Bengal" },
  { value: "Other", text: "Other" }
];

export const courseOptions = [
  { value: null, text: "Select A Course *" },
  { value: "Bachelors", text: "Bachelors" },
  { value: "Diploma", text: "Diploma" },
  { value: "Masters", text: "Masters" },
  { value: "MBA", text: "MBA" },
  { value: "PG", text: "PG" },
  { value: "Course Not Available", text: "Course Not Available" }
];

export const specializationOptions = [
  { value: null, text: "Select A Course *" },
  { value: "Arts and Design", text: "Arts and Design" },
  { value: "Business Management", text: "Business Management" },
  { value: "Computer and IT", text: "Computer and IT" },
  { value: "Engineering", text: "Engineering" },
  { value: "Hospitality", text: "Hospitality" },
  {
    value: "Media and Mass Communication",
    text: "Media and Mass Communication"
  },
  { value: "Medicine", text: "Medicine" },
  { value: "Science", text: "Science" }
];

export const cityOptions = [
  { value: null, text: "Select A City *" },
  ...jsonData.map(cityName => ({ text: cityName, value: cityName }))
];




// WEBPACK FOOTER //
// ./src/components/partials/sefDetails.js